import {PageBody, PageCardWrapper, PageContent, PageWrapper} from '@/components/ui/page-atoms/PageAtoms'
import styled, {css} from 'styled-components'

export const StyledPageWrapper = styled(PageWrapper)(
    () => css`
        overflow: hidden;
    `
)

export const StyledPageBody = styled(PageBody)(
    () => css`
        grid-template-rows: auto minmax(0, 1fr);
        overflow-y: hidden;
    `
)

export const StyledPageContent = styled(PageContent)(
    () => css`
        overflow-y: hidden;
    `
)

export const StyledCardWrapper = styled(PageCardWrapper)(
    () => css`
        overflow-y: hidden;
    `
)

export const StyledSelectCell = styled.div(
    ({theme: {spacing}}) => css`
        display: flex;
        align-items: center;
        justify-content: flex-end;
        width: 100%;
        padding: ${spacing * 0.5}px;
    `
)
